import { z } from 'zod'

export const establishmentRequiredDocumentCreateSchema = z
  .object({
    display_name: z
      .string()
      .trim()
      .min(3, { message: 'Tamanho mínimo: 3 caracteres' })
      .max(32, { message: 'Tamanho máximo: 32 caracteres' }),
    has_default_validity_in_days: z.boolean(),
    default_validity_in_days: z.string().optional(),
    file_sample: z.custom<File | string>().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.has_default_validity_in_days) {
      if (!data.default_validity_in_days) {
        return ctx.addIssue({
          path: ['default_validity_in_days'],
          code: z.ZodIssueCode.custom,
          message: 'Campo obrigatório',
        })
      }

      if (data.default_validity_in_days && Number(data.default_validity_in_days) <= 0) {
        return ctx.addIssue({
          path: ['default_validity_in_days'],
          code: z.ZodIssueCode.custom,
          message: 'Validade padrão em dias deve ser maior ou igual a 1',
        })
      }
    }
  })

export type EstablishmentRequiredDocumentValidationSchema = z.infer<typeof establishmentRequiredDocumentCreateSchema>
